import { render, staticRenderFns } from "./TopFaq.vue?vue&type=template&id=99e9afee&scoped=true"
import script from "./TopFaq.vue?vue&type=script&lang=js"
export * from "./TopFaq.vue?vue&type=script&lang=js"
import style0 from "./TopFaq.vue?vue&type=style&index=0&id=99e9afee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e9afee",
  null
  
)

export default component.exports